import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Box,
} from "@mui/material";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import { getFromStorage } from "helpers";
import { STORAGE_KEYS } from "helpers";

export default function ExchangeDetails({ orderData, type }) {
  const currency = getFromStorage(STORAGE_KEYS.currency);
  const calculateTotal = (quantity, price) => {
    const numericQuantity = parseFloat(quantity);
    return numericQuantity * parseFloat(price);
  };

  const products =
    type === 2
      ? orderData?.exchange_product_list
      : orderData?.return_product_list;

  return (
    <Box padding={4}>
      <Typography variant="h5" fontWeight="bold" mb={3}>
        Return/Exchange #{orderData?.order_track_id}
      </Typography>

      <Grid container spacing={3}>
        {/* Order Items */}
        <Grid item xs={12} md={8}>
          <Card sx={{ borderWidth: 1, borderColor: "grey" }}>
            <CardHeader
              avatar={<ShoppingCartOutlinedIcon />}
              title="Products List"
            />
            <CardContent>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Item</TableCell>
                      <TableCell align="left">Quantity</TableCell>
                      <TableCell align="right">Price</TableCell>
                      <TableCell align="right">Total</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {products?.map((item) => (
                      <TableRow key={item.id}>
                        <TableCell align="left">
                          {item?.product_name_en || "-"}
                        </TableCell>
                        <TableCell align="left">{item?.buy_quantity}</TableCell>
                        <TableCell align="right">
                          {currency === "USD" ? "USD" : "AED"}{" "}
                          {item?.price_per_unit || "-"}
                        </TableCell>
                        <TableCell align="right">
                          {currency === "USD" ? "USD" : "AED"}{" "}
                          {calculateTotal(
                            item?.buy_quantity,
                            item?.price_per_unit
                          ) || "-"}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>

        {/* Order Summary */}
        <Grid item xs={12} md={4}>
          <Card sx={{ borderWidth: 1, borderColor: "grey" }}>
            <CardHeader
              avatar={<ReceiptOutlinedIcon />}
              title="Order Summary"
            />
            <CardContent>
              <Box display="flex" justifyContent="space-between" mb={1}>
                <Typography>Subtotal:</Typography>
                <Typography>
                  {currency === "USD" ? "USD" : "AED"}{" "}
                  {type === 1
                    ? orderData?.total_cost_pay || "0"
                    : orderData?.sub_total || "0"}
                </Typography>
              </Box>
              {type === 1 ? (
                <Box display="flex" justifyContent="space-between" mb={1}>
                  <Typography>Return Reason:</Typography>
                  <Typography>{orderData?.return_reason || "-"}</Typography>
                </Box>
              ) : null}

              <Box display="flex" justifyContent="space-between" mb={1}>
                <Typography>Refund Amount:</Typography>
                <Typography>
                  {currency === "USD" ? "USD" : "AED"}{" "}
                  {type === 1 ? orderData?.amount_pay : orderData?.refund_pay}
                </Typography>
              </Box>
              {type === 1 ? null : (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  fontWeight="bold"
                >
                  <Typography>Extra Payment By User:</Typography>
                  <Typography>
                    {currency === "USD" ? "USD" : "AED"}{" "}
                    {orderData?.extra_amount_pay || "0"}
                  </Typography>
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>

        {/* Delivery Information */}
        <Grid item xs={12} md={4}>
          <Card sx={{ borderWidth: 1, borderColor: "grey" }}>
            <CardHeader
              avatar={<LocalShippingOutlinedIcon />}
              title="Delivery Information"
            />
            <CardContent>
              {/* <Typography>
                <strong>Status:</strong>{" "}
                {orderData?.Return_status === 1
                  ? "Order Placed"
                  : orderData?.Return_status === 2
                  ? "In Progress"
                  : orderData?.Return_status === 3
                  ? "Shipping"
                  : "Delivered"}
              </Typography> */}
              <Typography>
                <strong>Address:</strong>{" "}
                {`${orderData?.pick_up_address?.business_address}, ${orderData?.pick_up_address?.city}`}
              </Typography>
              <Typography>
                <strong>Instructions:</strong> {orderData?.return_reason || "-"}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
